export const CATS_CUSTOMER_CONTROLLER_ROOT_PATH = "/customer";

export const CATS_CUSTOMER_GET_ALL_PATH_SUFFIX = "/cats";

export const CATS_CUSTOMER_UPDATE_DETAILS_PATH_SUFFIX = "/cat/update";
export const CATS_CUSTOMER_UPDATE_DETAILS_PATH =
  CATS_CUSTOMER_CONTROLLER_ROOT_PATH + CATS_CUSTOMER_UPDATE_DETAILS_PATH_SUFFIX;

export const CATS_CUSTOMER_CREATE_PATH_SUFFIX = "/cat/create";
export const CATS_CUSTOMER_CREATE_PATH = CATS_CUSTOMER_CONTROLLER_ROOT_PATH + CATS_CUSTOMER_CREATE_PATH_SUFFIX;

export const CATS_ADMIN_CONTROLLER_ROOT_PATH = "/admin";

export const CATS_ADMIN_GET_ALL_PATH_SUFFIX = "/cats";

export const CATS_ADMIN_UPDATE_DETAILS_PATH_SUFFIX = "/cat/update/:userId";

export const CATS_ABANDONED_CART_INTERNAL_ROOT_PATH = "/abandoned-cart/internal";

export const CATS_ABANDONED_CART_INTERNAL_FRESH_SUFFIX = "/fresh";
export const CATS_ABANDONED_CART_INTERNAL_FRESH_PATH = `${
  CATS_ABANDONED_CART_INTERNAL_ROOT_PATH
}${
  CATS_ABANDONED_CART_INTERNAL_FRESH_SUFFIX
}`;

export const CATS_ABANDONED_CART_INTERNAL_SCOOP_SUFFIX = "/scoop";
export const CATS_ABANDONED_CART_INTERNAL_SCOOP_PATH = `${
  CATS_ABANDONED_CART_INTERNAL_ROOT_PATH
}${
  CATS_ABANDONED_CART_INTERNAL_SCOOP_SUFFIX
}`;
